import React from 'react';
import { Platform } from 'react-native';
import { Redirect } from 'expo-router';
export default function PluginsRoute() { return <Redirect href={Platform.OS === 'macos' ? { pathname: '/settings', params: { page: 'plugins' } } : '/settings'} />; }
